import { inject, provideAppInitializer } from '@angular/core';

import { LOP_NOTIFICATIONS } from '@lop/models/lop-notifications';
import { NotificationEntitiesService } from '@notifications/services/notification-entities.service';

export function registerLopNotifications(): Promise<void> {
  const notificationEntitiesService = inject(NotificationEntitiesService);

  notificationEntitiesService.registerEntities(LOP_NOTIFICATIONS);

  return Promise.resolve();
}

export const LOP_INITIALIZER = provideAppInitializer(() =>
  registerLopNotifications()
);
